import initCustomDropdown from './initCustomDropdown.js';
import { getCsrf } from './book/api.js';

export default function initContactForm () {
    const form = document.getElementById('medForm');
    const wrapper = document.getElementById('formWrapper');
    if (!form || !wrapper) return;

    const nameInput = form.querySelector('#fullName');
    const phoneInput = form.querySelector('#phone');
    const emailInput = form.querySelector('#email');
    const messageInput = form.querySelector('#message');
    const submitBtn = form.querySelector('#submitBtn');
    if (!nameInput || !phoneInput || !emailInput || !messageInput || !submitBtn) return;

    const closeBtn = document.getElementById('closeThankYou');
    const formDropdown = initCustomDropdown('#medForm');
    if (!formDropdown) return;

    const formatPhoneValue = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, 10);
        const part1 = digits.slice(0, 3);
        const part2 = digits.slice(3, 6);
        const part3 = digits.slice(6, 10);

        if (digits.length <= 3) {
            return part1 ? `(${part1}` : '';
        }

        if (digits.length <= 6) {
            return `(${part1}) ${part2}`;
        }

        return `(${part1}) ${part2}-${part3}`;
    };

    const isPhoneValid = (value) => value.replace(/\D/g, '').length === 10;

    messageInput.addEventListener('input', () => {
        if (messageInput.value.trim()) {
            messageInput.classList.remove('is-invalid');
        }
    });

    nameInput.addEventListener('input', () => {
        if (nameInput.value.trim()) {
            nameInput.classList.remove('is-invalid');
        }
    });

    phoneInput.addEventListener('input', (e) => {
        const input = e.target;
        const digits = input.value.replace(/\D/g, '').slice(0, 10);

        input.value = digits ? formatPhoneValue(digits) : '';

        if (isPhoneValid(input.value)) {
            input.classList.remove('is-invalid');
        }
    });

    emailInput.addEventListener('input', () => {
        if (emailInput.value.trim()) {
            emailInput.classList.remove('is-invalid');
        }
    });

    phoneInput.addEventListener('input', () => {
        if (phoneInput.value.trim()) {
            phoneInput.classList.remove('is-invalid');
        }
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        let isValid = true;

        if (!formDropdown.isSelected()) {
            formDropdown.setError();
            isValid = false;
        }

        if (!nameInput.value.trim()) {
            nameInput.classList.add('is-invalid');
            isValid = false;
        }

        // At least one of email or phone must be filled
        const hasEmail = emailInput.value.trim();
        const hasPhone = phoneInput.value.trim();

        if (!hasEmail && !hasPhone) {
            emailInput.classList.add('is-invalid');
            phoneInput.classList.add('is-invalid');
            isValid = false;
        }

        if (!messageInput.value.trim()) {
            messageInput.classList.add('is-invalid');
            isValid = false;
        }

        if (isValid) {
            submitBtn.classList.remove('btn-outline-gradient');
            submitBtn.classList.add('btn-gradient');

            // Get CSRF token
            const csrf = getCsrf();

            // send form data via AJAX
            const formData = {
                name: nameInput.value.trim(),
                email: emailInput.value.trim(),
                phone: phoneInput.value.trim(),
                state: formDropdown.getSelectedValue(),
                message: messageInput.value.trim(),
                [csrf.name]: csrf.hash
            };

            fetch('/contact/send_form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrf.hash,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Form successfully submitted:', data);
            })
            .catch(error => {
                console.error('There was a problem with the form submission:', error);
            });

            wrapper.classList.add('form-submitted');
        }
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            wrapper.classList.remove('form-submitted');
            form.reset();
            phoneInput.value = '';

            [nameInput, phoneInput, emailInput, messageInput].forEach(input =>
                input.classList.remove('is-invalid')
            );

            formDropdown.reset();
        });
    }
}
